<mat-form-field floatLabel="always" class="col-12" subscriptSizing="dynamic">
  <mat-label>
    {{ schema.title }}
    @if (schema.default && schema.minLength === 0) {
      <ng-container> (Default: {{schema.default || defaultValue}}) </ng-container>
    }
  </mat-label>

  <textarea
    class="col-12"
    matInput
    [formControl]="aFormControl"
    [placeholder]="schema.minLength !== undefined ? '' : (defaultValue || schema.default || '').toString()"
    rows="10"
  ></textarea>

  @if (
    !(aFormControl.value === schema.default || aFormControl.value === defaultValue || aFormControl.value === null) && schema.minLength !== undefined
  ) {
    <button
      matSuffix
      mat-icon-button
      aria-label="Reset to default"
      matTooltip="Reset to default"
      (click)="resetToDefault()"
    >
      <mat-icon>refresh</mat-icon>
    </button>
  }

  @if (schema.description) {
    <mat-hint>
      {{schema.description}}
    </mat-hint>
  }

  @if (aFormControl.invalid && (aFormControl.dirty || aFormControl.touched)) {
    @if (aFormControl.errors?.required) {
      <mat-error>This field is required.</mat-error>
    }
    @if (aFormControl.errors?.minlength) {
      <mat-error>Minimum length is not met.</mat-error>
    }
    @if (aFormControl.errors?.maxlength) {
      <mat-error>Maximum length exceeded.</mat-error>
    }
  }
</mat-form-field>
